import React from 'react';
import { Input, Typography } from 'antd';
import { useI18n } from '../../i18n';

const { TextArea } = Input;
const { Text } = Typography;

/**
 * SelectionWizard step 3 (inquiry-module-redesign follow-up, Requirement 7
 * — revised): a free-text Logistics note instead of a catalogue selection.
 * There's no per-item shipping/delivery catalogue row to pick here — the
 * requester simply describes what this category needs (incoterm, freight
 * mode, packaging/handling constraints, delivery window, ...). The text is
 * stored on the wizard result as `logisticsNotes` and shown next to the
 * Products/Services supplier summary wherever that's rendered (the Inquiry
 * Item's Sourcing column) — it carries no supplier of its own.
 */
export default function LogisticsStep({ logisticsNotes = '', onChange }) {
  const { t } = useI18n();

  return (
    <div>
      <Text style={{ display: 'block', marginBottom: 8 }}>
        {t('Describe the shipping, delivery, and handling requirements for this category.')}
      </Text>
      <TextArea
        value={logisticsNotes}
        onChange={(e) => onChange(e.target.value)}
        placeholder={t('e.g. Sea freight from Ningbo, DDP Copenhagen, palletised, temperature-controlled...')}
        autoSize={{ minRows: 12, maxRows: 24 }}
        maxLength={2000}
        showCount
      />
    </div>
  );
}
